export default {
      id: "x-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#x",
      toString: function () {
        return this.url;
      }
    }